module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_8"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_4"
    }
  }, [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("The creation of "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(" was significantly influenced, spurred on, and shaped by many friends over a three-year period. For all of you, I am profoundly grateful, not only for your help, but for "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("who you are")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("My beloved wife, Theresa, and all of our family members, in particular Maria Mascia and Catherine Williamson, were my secret spring of love and support, motivating me to keep calm and carry on to the finish line.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Perry Cahall, PhD, the academic dean at the Josephinum, as well as a friend and mentor, was one of the first non-family members to review the draft of my manuscript, encouraging me to pursue publication.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Joop Koopman, the Communications Director for the Aid to the Church in Need in Brooklyn, NY, has been a constant and reliable source of practical help and advice from the very beginning of the project to its completion.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Stephen M. Rasche, author of "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("The Disappearing People")]), _vm._v(", generously shared his first-hand knowledge of Karemlesh, the Nineveh plains, and the culture of Iraq with me, allowing me to authenticate many historical details. On more than one occasion, he reviewed my manuscript to make sure the plot elements were consistent with the events of 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Joseph Head, a friend of many years, offered me many hours of editorial and creative help as the manuscript expanded and evolved.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("John Cerullo, a true gentleman with a lifetime of publishing experience, affirmed early on that my story should be in print. John patiently guided me through the process of finding a reputable publisher that would be the right fit for "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Nazar’s Journey")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Dr. Richard Fitzgerald, Amanda Mole, and the choir of St Joseph Cathedral here in Columbus inspired me to create the scene under the stars. I was attending Compline in the solemn candle-lit cathedral one evening when I heard Richard’s composition of the Psalm 90 (91) antiphon sung by the choir—“He will conceal you in His wings. You will not fear the terror of the night.” While listening to this transporting piece, the scene of Amira and Nazar gazing up at the stars suddenly appeared in my imagination.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Mother Olga Yacob of the Daughters of Mary of Nazareth, Deacon Sermed Ashkouri, Qais Al Sindy, and Fady Aqrawi are Americans who grew up in Iraq and know the language and culture intimately. They were pivotal in providing the expressions in Sureth, a form of Aramaic used in Nineveh, which I included in my dialogues. The translation of the words from Psalm 91 into Sureth was done by Fady.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Brother Joe Donovan, a graduate of the Pennsylvania Academy of Fine Arts, a friend and longtime member of the Brotherhood of Hope, was my artistic advisor regarding the cover design. He created the imaginative Tolkienesque map which is found at the start of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Although I could devote a page to each of these individuals who took their time to read my manuscript and write such fine endorsements, for brevity sake I will simply mention their names as an expression of my deep appreciation for their efforts: Weam Namou, Gabriel Meyer, Dr. Aaron Urbanczyk, Ismail Royer, and Father Ben Kiely. I am also profoundly grateful for Joseph Pearce’s encouragement and his inspiring introduction, and for Stephen Rasche’s insightful Afterword. The amazing paintings of Qais Al Sindy are described in detail in my About the Artwork. I cannot express in words how much I appreciate his collaboration. His boundless creativity exceeded all my expectations.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("I am also grateful to the following individuals, who offered me assistance by reviewing or critiquing my work, by words of encouragement, or by their prayers:")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Sister Mary Ann Fatula, PhD, Rachel and Chris Padian, Fr. Timothy Lynch, Carol, Sarah, and Hannah Stollenwerk, John Hack, Brendan O’Rourke, Fr. Matthew Morris, Joseph M. Mascia, Matt Palmer, M. Lennon Perricone, John Donelan, Nathaniel Earls, Dr. Bruce Fraser, Michael O’Brien, Debra Esolen, Jim Haban, Carlos Posada, Amira and Erdal Unver, Fr. Peter John Cameron, Fr. Bernard Marie of the Franciscan Friars in London, Dr. Linus Meldrum, Brother Jude LaSota, Gregory C. Floyd, Tom Morris, Paul Wills, Dr Marlon De La Torre, Mark Huddy, George Rushman, Dick Hintershied, Michael Agriesti, Jerry Freewalt, Albert Vautour, Chris Schweitzer, Irene and Bill Brundage and Peter Krajnak.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Finally, I am indebted to several writer-saints whom I have frequently implored for inspiration—St Paul, Therese of Lisieux, Teresa of Avila, John Henry Newman, Thomas Aquinas, and, of course, Catherine of Siena.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75eb597b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 72
// module chunks = 0